
















































import {Component, Emit, Inject, Watch} from "vue-property-decorator";
import {
    TerminalLocation,
    TerminalLocationExportserviceInfo,
    TerminalLocationHmsregInfo
} from "../../modules/models";
import Api from "./Api";
import CommonBase from "../CommonBase";
import SendSiosQuestion from "../SendSiosQuestion.vue";
import RegWithoutTerminalInfoDialog from "./RegWithoutTerminalInfoDialog.vue";
import CompanyUserRequired from "../CompanyRequired";

@Component({
    components: {
        "at-send-sios-question": SendSiosQuestion,
        "at-without-terminal-dialog": RegWithoutTerminalInfoDialog
    }
})
export default class TerminalLocationDialog extends CompanyUserRequired {
    @Inject()
    api!: Api;

    opened = false;
    saving = false;
    id: number = 0;
    description: string = "";
    address: string | null = "";
    constructorName: string | null = "";
    invoiceRef: string | null = "";
    unverifiedRegsOk = false;
    regWithoutTerminal = false;
    showRegWithoutTerminalInfo = false;
    onRegWithoutTerminalChanged(newVal) {
        if(newVal) {
            this.showRegWithoutTerminalInfo = true;
        }
    }
    mobileRegGeoRequired = true;
    mobileRegRegcodeRequired = true;
    requirePhoneAuth = false;
    hseGuideline = 0;

    get existing() {
        return this.id >= 1;
    }

    hmsregInfo = new TerminalLocationHmsregInfo(null, false);

    exportServiceInfoList: TerminalLocationExportserviceInfo[] = [];

    set hmsregIsCompanyActivated(is: boolean) {
        this.hmsregInfo.isCompanyActivated = is;
    }
    get hmsregIsCompanyActivated() {
        return this.hmsregInfo.isCompanyActivated;
    }

    validateDescription() {
        return this.description.trim().length > 2 || "Beskrivelse må ha minst tre tegn";
    }
    get isValid() {
        return this.validateDescription() === true;
    }
    get companyName() {
        return this.company != null ? this.company.name: null;
    }

    async open(loc: TerminalLocation, hmsregInfo: TerminalLocationHmsregInfo | null, exportServiceInfoList: TerminalLocationExportserviceInfo[]) {
        await this.baseApi.loadCompanyPromise(); // TODO rewrite to avoid special promise method
        if(loc.id == null || loc.id < 1) {
            throw new Error("TerminalLocation.id must be specified for TerminalLocationDialog.open");
        }
        this.id = loc.id;
        this.description = loc.description;
        this.address = loc.address;
        this.constructorName = loc.constructorName;
        this.invoiceRef = loc.invoiceRef;
        this.unverifiedRegsOk = loc.unverifiedRegsOk;
        this.regWithoutTerminal = loc.regWithoutTerminal;
        this.mobileRegGeoRequired = loc.mobileRegGeoRequired;
        this.mobileRegRegcodeRequired = loc.mobileRegRegcodeRequired;
        this.requirePhoneAuth = loc.requirePhoneAuth;
        this.hseGuideline = loc.hseGuidelineEnabled;
        if(hmsregInfo != null) {
            this.hmsregInfo = hmsregInfo.clone();
        } else {
            this.hmsregIsCompanyActivated = await this.api.hmsregIsCompanyActivated(this.company.orgNum);
        }
        if(exportServiceInfoList != null) {
            this.exportServiceInfoList = exportServiceInfoList.map((info: TerminalLocationExportserviceInfo) => info.clone());
        } else {
            this.exportServiceInfoList = await this.api.companyExportserviceInfoList(this.company.orgNum);
        }
        this.opened = true;
    }
    close() {
        this.opened = false;
    }
    @Emit("at-terminal-location-changed")
    emitLocationChange() {
    }
    @Emit("at-terminal-location-created")
    emitLocationCreated(msg: string) {
    }
    async save() {
        this.saving = true;
        try {
            // updateExisting existing
            await this.updateExisting();
            this.emitLocationChange();
            this.close();

        } catch(err) {
            this.emitError(err);
        } finally {
            this.saving = false;
        }
    }
    async updateExisting() {
        const loc = new TerminalLocation(
            this.id, this.description, this.company.orgNum, this.unverifiedRegsOk, null, this.address,
            this.constructorName, this.invoiceRef, this.regWithoutTerminal,
            this.mobileRegGeoRequired, this.mobileRegRegcodeRequired, this.requirePhoneAuth, this.hseGuideline, false, true
        );
        await this.api.updateTerminalLocation(loc);
        const sioCount = await this.api.hmsregLocationUpdate(loc.id, this.hmsregInfo.regnum);
        if(sioCount) {
          const sendEarlierSios = await this.sendEarlierSiosChoice(sioCount, "HMSREG");
          if (sendEarlierSios) {
            await this.api.sendSiosToHmsreg(loc.id);
          }
        }
        // find what (if any) exportserviceInfos has changed.
        const origExportserviceInfos = await this.api.locationExportserviceInfoList(this.company.orgNum, this.id);
        const changedExportserviceInfos = this.exportServiceInfoList.filter((info, idx) => info.locationExportRef != origExportserviceInfos[idx].locationExportRef);
        if(changedExportserviceInfos.length > 0) {
            // save the changes, and ask user if he wants to (re)send sios on them if they return a siocount
            const sioCount = await this.api.saveExportserviceInfos(loc.id, changedExportserviceInfos);
            if(sioCount > 0) {
                for(let expSvc of changedExportserviceInfos) {
                    if(await this.sendEarlierSiosChoice(sioCount, expSvc.description)) {
                        await this.api.sendExportserviceSios(loc.id, expSvc.id);
                    }
                }
            }
        }
    }

    async sendEarlierSiosChoice(sioCount: number, description: string): Promise<boolean> {
        if(sioCount > 0) { // display choice for user to resend sios
            const sendSiosQ = (this.$refs.SendSiosQ as SendSiosQuestion);
            const ret: Promise<boolean> = CommonBase.oneEventPromise(sendSiosQ, "send-sios-answer");
            sendSiosQ.ask(description, sioCount);
            return ret;
        } else {
            return false;
        }
    }
}
